<script setup lang="ts">
import { useToast } from '@/composables/useToast'

const { visible, icon, toastClass, hideToast, currentToast } = useToast()

const getFallbackIcon = (): string => {
  const type = currentToast?.value?.type
  switch (type) {
    case 'success':
      return '✓'
    case 'error':
      return '✕'
    case 'warning':
      return '⚠'
    default:
      return 'ℹ'
  }
}
</script>

<template>
  <div
    v-if="visible"
    :class="[
      'fixed bottom-6 z-[999999] right-6 p-4 rounded-2xl shadow-lg flex items-center gap-4 min-w-80 max-w-md',
      toastClass,
    ]"
    @click="hideToast"
  >
    <div
      v-if="icon && typeof icon === 'object'"
      class="border rounded-full text-xs w-6 h-6 aspect-square flex items-center justify-center"
    >
      <component :is="icon" />
    </div>
    <div
      v-else
      class="border rounded-full text-xs w-6 h-6 aspect-square flex items-center justify-center"
    >
      {{ getFallbackIcon() }}
    </div>
    <div class="flex-1">
      <h3 class="text-sm font-semibold">{{ currentToast?.title }}</h3>
      <p class="text-xs text-gray-600 mt-1">{{ currentToast?.message }}</p>
    </div>

    <button
      class="ml-2 text-gray-400 hover:text-gray-600 text-xl font-bold cursor-pointer"
      @click.stop="hideToast"
    >
      &times;
    </button>
  </div>
</template>

<style scoped>
.fixed {
  transition: all 0.3s ease-in-out;
  opacity: 1;
  transform: translateY(0);
}
</style>
